import { authConstants } from "../../actions/auth/index";
import { usersConstants } from "../../actions/users/index";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    },
    message: ""
  },
  loginAuth: null,
  previousToken: null,
  isRefreshingToken: false
};

export default function auth(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;

  switch (type) {
  case "persist/PERSIST":
  case "@@INIT":
    /** metto lo spinner attivo per non far apparire la login ad ogni refresh */
    return {
      ...defaultS,
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case "persist/REHYDRATE":
    return {
      ...(payload?.auth || defaultS),
      status: {
        started: false,
        error: false,
        ended: typeof payload?.auth.loginAuth?.auth !== "undefined"
      }
    };
  case "CALLWITHRETRY_REFRESH_TOKEN_TSID_START":
  case "CALLWITHRETRY_REFRESH_TOKEN_START":
    return {
      ...defaultS,
      previousToken: payload,
      isRefreshingToken: true
    };
  case "CALLWITHRETRY_REFRESH_TOKEN_ERROR":
  case "CALLWITHRETRY_REFRESH_TOKEN_SUCCESS":
  case "CALLWITHRETRY_REFRESH_TOKEN_TSID_ERROR":
    return {
      ...defaultS,
      isRefreshingToken: false
    };
  case "CALLWITHRETRY_REFRESH_TOKEN_TSID_SUCCESS":
    return {
      ...state,
      isRefreshingToken: false,
      loginAuth: {
        ...state?.loginAuth,
        ...payload
      }
    };
  case authConstants.LOGIN_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false,
        message: ""
      },
      previousToken: defaultS.previousToken,
      isRefreshingToken: defaultS.isRefreshingToken
    };
  case authConstants.LOGIN_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true,
        message: ""
      },
      previousToken: defaultS.previousToken,
      isRefreshingToken: defaultS.isRefreshingToken,
      ...payload
    };
  case usersConstants.PUT_ACCOUNT_USERS_PASSWORD_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: false,
        message: "Password cambiata con successo! Effettua il login"
      },
      previousToken: defaultS.previousToken,
      isRefreshingToken: defaultS.isRefreshingToken
    };
  case authConstants.LOGIN_ERROR:
  case usersConstants.LOAD_USER_ERROR:
  case usersConstants.PUT_ACCOUNT_USERS_PASSWORD_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: {
          code: payload.code ? payload.code : payload.message?.includes("Password scaduta") ? "403.1" : "403",
          message: payload.message
        },
        message: ""
      },
      oldAuth: defaultS.loginAuth,
      previousToken: defaultS.previousToken,
      isRefreshingToken: defaultS.isRefreshingToken
    };
  case authConstants.LOGIN_RESET:
    return {
      ...defaultState
    };
  case "UPDATE_LOGIN_DATA_AUTH":
    return { ...payload, status: { started: false, ended: true, error: false } };
  case authConstants.REFRESH_START:
    return {
      status: { started: true, ended: false, error: false } 
    };
  case authConstants.REFRESH_SUCCESS:
    
    return {
      status: { started: false, ended: true, error: false },
      previousToken: null,
      isRefreshingToken: false,
      loginAuth: {
        securityToken: payload.applicationToken,
        id: "1afdf404-6562-4a29-9a7c-84fbabab9ac2",
        idToken: payload.idToken,
        appName: "DIGITALBOXWEB",
        refreshToken: payload.refreshToken,
        correlationId: payload.correlationId,
        requestId: payload.requestId,
        loginMethod: "tsid"
      },
      securityToken: payload.applicationToken,
      accessToken: payload.applicationToken
   
    };
  case authConstants.REFRESH_ERROR:
    return {
      status: { started: false, ended: false, error: true }     
    };
  default:
    return defaultS;
  }
}
